let gateProxy = 'http://192.168.2.132:5002';
let homeProxy = 'http://192.168.178.99:5002';
let liveProxy = 'https://reporting-backend.gate-internet.de';
// export const host = 'http://172.16.28.155:5002';
var dev = false;
var home = true;
export const proxy = dev ? (home ? homeProxy : gateProxy) : liveProxy;
export const host = dev ? (home ? homeProxy : gateProxy) : liveProxy;
